/**
 * Phase 3 — Refinance lender rate table.
 *
 * Thin vertical wrapper around the shared `<PartnerRateTable />`
 * engine that hardcodes `category="refinance"`. Phase 3 rationale:
 * see /components/tables/InsuranceCarrierTable.jsx.
 */
import React from "react";
import PartnerRateTable from "../PartnerRateTable";
import { REFINANCE_CONFIG } from "../../features/refinance/config";

export default function RefinanceLenderTable({
  sourcePage,
  title,
  subtitle,
  limit = 10,
  creditMax,
  creditMin,
  onListChange,
  enableFilters = false,
  suppressMethodologyBadge = false,
}) {
  return (
    <div data-testid="refinance-lender-table">
      <PartnerRateTable
        category="refinance"
        sourcePage={sourcePage}
        title={title || REFINANCE_CONFIG.rateTable.headerLabel}
        subtitle={subtitle}
        limit={limit}
        creditMax={creditMax}
        creditMin={creditMin}
        onListChange={onListChange}
        enableFilters={enableFilters}
        suppressMethodologyBadge={suppressMethodologyBadge}
      />
    </div>
  );
}
